module.exports = __webpack_public_path__ + "img/KEN_highway-photo-2.a258626a.jpg";